// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowListModal-cls1_aBx","cls2":"BulkFollowListModal-cls2_2Zd BulkFollowListModal-cls1_aBx"};